// bind_Modal
import bind_modal from '@/components/AreaBind';

// success_Modal
import success_modal from '@/components/SuccessModal';

// error_Modal
import error_modal from '@/components/ErrorModal';

// qr_Modal
import qr_modal from '@/components/QrModal';

// copy_Modal
import copy_modal from '@/components/CopyModal';

// invite_apply
import invite_apply from '@/components/inviteApply';

// reward_success
import reward_success from '@/components/RewardModal';

// rule_modal
import rule_modal from '@/components/RuleModal';

// key_modal
import key_modal from '@/components/KeyModal';


let utils = {
    $bind_modal : bind_modal,
    $success_modal : success_modal,
    $qr_modal : qr_modal,
    $error_modal : error_modal,
    $copy_modal : copy_modal,
    $apply_modal : invite_apply,
    $reward_success : reward_success,
    $rule_modal : rule_modal,
    $key_modal : key_modal,
}

export default utils;


// WEBPACK FOOTER //
// ./src/assets/js/utils.js